import React from 'react';
import stripeLogoSmall from '../../../../assets/images/billing/stripe-logo-small.svg';
function StripeSecureInfo({ disabled }) {
    return <div>
        <div className={`stripe-secure-info ${disabled && 'disabled'}`}>
            <i className="icon icon-alan-lock-small" />
            Secure checkout. You’re 100% covered by our 30&#8288;-&#8288;day money&#8288;-&#8288;back guarantee.
        </div>
        <div className={`stripe-secure-info__powered-by ${disabled && 'disabled'}`}>
            <a target="_blank" rel="noreferrer"
                href="https://stripe.com/">
                <img src={stripeLogoSmall} />
            </a>
        </div>
    </div>;
}

export default StripeSecureInfo;
